module.exports = "<iframe [src]=\"url\" class=\"asp-iframe\"></iframe>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/nepriznata-emitovanja/nepriznata-emitovanja.component.html
// module id = ./src/app/pages/nepriznata-emitovanja/nepriznata-emitovanja.component.html
// module chunks = main